(function () {
  const isNodeJS = typeof exports !== 'undefined' ? exports : null;

  class ConstructionHelpers {
    constructor (options = {}) {
      Object.keys(options).forEach((key) => {
        this[key] = options[key];
      });
    }

    getBasicAreas (project) {
      return [...project.basicAreas];
    }

    getAreas (project) {
      return project.buildings.reduce((buildingAcc, building) => {
        const buildingAreas = building.clusters.reduce((clusterAcc, cluster) => [...clusterAcc, ...cluster.areas], []);
        return [...buildingAcc, ...buildingAreas];
      }, []);
    }

    getBuildings (project) {
      return [...project.buildings];
    }

    getConstructions (project, {
      versionId,
      includeProject = true,
      includeBuilding = true,
      includeAreas = true,
      includeBasicAreas = true
    }) {
      let version = project;
      let constructions = [];

      if (versionId) {
        version = project.versions.find((v) => v._id.toString() === versionId.toString());
      }

      if (includeProject) {
        constructions = [...constructions, project];
      }
      if (includeBuilding) {
        constructions = [...constructions, ...this.getBuildings(version)];
      }
      if (includeBasicAreas) {
        constructions = [...constructions, ...this.getBasicAreas(version)];
      }
      if (includeAreas) {
        constructions = [...constructions, ...this.getAreas(version)];
      }

      return constructions;
    }

    getConstructionByConstructionId ({ constructionId, project, options = {} }) {
      // @ts-ignore
      return this.getConstructions(project, options).find((c) => c._id.toString() === constructionId.toString());
    }
  }

  if (isNodeJS) {
    exports.ConstructionHelpers = ConstructionHelpers;
  } else {
    (function () {
      angular
        .module('specsguardApp')
        .factory('sgConstructionHelpers', sgConstructionHelpers);

      function sgConstructionHelpers () {
        return ConstructionHelpers;
      }
    })();
  }
})();
